let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g6LyJ")).then(() => parcelRequire('1H43T'));